<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d9unQg/tc-custom/9780544230965.jpg?1737196285788" alt="This image is the cover for the book Six Memos for the Next Millennium"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Six Memos for the Next Millennium
      </h1>
      <p class="bookDescription body article font2">
        <b>The celebrated author of <i>Cosmicomics</i> and <i>Invisible Cities</i> shares his “brilliant, original approach to literature” in these late-career lectures (<i>San Francisco Chronicle</i>).</b><br/>  <br/> At the time of his death, Italo Calvino was at work on his Charles Eliot Norton poetry lectures to be delivered the following year at Harvard University. The six planned lectures would define the qualities he most valued in writing, and which he believed would define literature in the century to come. <i>Six Memos for the Next Millennium</i> collects the five lectures he completed, forming not only a stirring defense of literature, but also an indispensable guide to the writings of Calvino himself.<br/>  <br/> He devotes one “memo” each to the concepts of lightness, quickness, exactitude, visibility, and multiplicity, drawing examples from his vast knowledge of myth, folklore, and works both ancient and modern. Written in the mid-1980s, these lectures have proven to be astonishingly prescient as we have entered Calvino’s “next millennium”.<br/>  <br/><b>“One of the most rigorously presented and beautifully illustrated critical testaments in all of literature.”—<i>Boston Globe</i></b><br/>  <br/><b>“A key to Calvino’s own work and a thoroughly delightful and illuminating commentary on some of the world’s greatest writing.”—<i>San Francisco Chronicle</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Italo Calvino
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6235c704